<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card>
        <b-row>
          <!-- <b-col>
            <b-form-group>
              <b-input-group>
                <b-form-input :placeholder="$t('global.search')" v-model="filters.search"></b-form-input>
                <b-input-group-append>
                  <b-button variant="primary" @click="getData()"><i class="fa fa-search"/></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col> -->
          <b-col>
            From
            <DatePicker format="DD.MM.YYYY hh:mm:ss" value-type="timestamp"
              :placeholder="$t('time_logs.filters.from_ts')" v-model="filters.from_ts"
            />
          </b-col>
          <b-col>
            To
            <DatePicker format="DD.MM.YYYY hh:mm:ss" value-type="timestamp"
              :placeholder="$t('time_logs.filters.to_ts')" v-model="filters.to_ts"
            />
          </b-col>
          <b-col>
          </b-col>
        </b-row>
        <div ref="charts">

        </div>
        <div v-if="loading" class="text-center">
          <b-spinner type="grow" variant="primary"/>
        </div>
        <div v-else>
          <!-- {{logs}} -->
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import ApexCharts from 'apexcharts';
import Services from '@/services/index';

export default {
  mounted() {
    this.getData();
  },
  props: ['page'],
  data() {
    return {
      filters: {
        from_ts: moment().subtract(30, 'days').valueOf(),
        to_ts: null,
        search: '',
        per_page: 20,
      },
      loading: false,
      logs: {},
      users: [],
      labelSets: [],
    };
  },
  components: {
    DatePicker
  },
  computed: {
    ...mapState('Auth', ['activeProjectId']),
    params() {
      return {
        ...this.filters,
        // page: this.page,
        // sort_order: this.filters.sort_order ? 'desc' : 'asc'
      };
    },
    days() {
      let from = moment(this.filters.from_ts);
      const to = moment(this.filters.to_ts || moment());
      const result = [];
      from = from.startOf('day');
      while (from <= to) {
        result.push(from.clone());
        from = from.add(1, 'days');
      }
      return result;
    }
  },
  watch: {
    page: 'getData',
    filters: { deep: true, handler: 'getData' },
  },
  methods: {
    getData() {
      this.loading = true;
      Services.timeLogs.list(this.activeProjectId, this.params).then(({ data }) => {
        // group by labelset
        const logsByLabelSet = data.logs.reduce((logs, l) => {
          if (!(l.label_set_id in logs)) {
            logs[l.label_set_id] = { logs: [] };
          }
          logs[l.label_set_id].logs.push(l);
          return logs;
        }, {});
        // group by user
        // eslint-disable-next-line camelcase
        Object.keys(logsByLabelSet).forEach((label_set_id) => {
          const logsByUser = logsByLabelSet[label_set_id].logs.reduce((logs, l) => {
            if (!(l.user_id in logs)) {
              logs[l.user_id] = { logs: [] };
            }
            logs[l.user_id].logs.push(l);
            return logs;
          }, {});
          // group per day
          // logsByLabelSet[label_set_id].logs = logsByUser;

          Object.keys(logsByUser).forEach((user_id) => {
            logsByUser[user_id].byDays = this.days.map((day) => {
              const dayTs = day.valueOf();
              const duration = logsByUser[user_id].logs.reduce((s, l) => {
                if (l.ts >= dayTs && l.ts < dayTs + 24 * 60 * 60 * 1000) {
                  s.d += l.duration;
                  s.c++;
                }
                return s;
              }, { d: 0, c: 0, day: day.clone() });
              return { duration };
            });
          });

          logsByUser[0] = {
            byDays: this.days.map((day) => {
              const dayTs = day.valueOf();
              const duration = logsByLabelSet[label_set_id].logs.reduce((s, l) => {
                if (l.ts >= dayTs && l.ts < dayTs + 24 * 60 * 60 * 1000) {
                  s.d += l.duration;
                  s.c++;
                }
                return s;
              }, { d: 0, c: 0, day: day.clone() });
              return { duration };
            })
          };

          logsByLabelSet[label_set_id].byUserByDays = logsByUser;

          // this.days.map((day) => {
          //   const dayTs = day.valueOf();
          //   const duration = logsByUser[user_id].logs.reduce((d, l) => {
          //     if (l.ts >= dayTs && l.ts < dayTs + 24 * 60 * 60 * 1000) d += l.duration;
          //     return d;
          //   }, 0);
          //   return { x: day.format('DD.MM.YYYY'), y: Math.round(duration / (60 * 1000)) };
          // });
        });
        this.logs = logsByLabelSet;
        this.users = data.users.reduce((m, u) => { m[u.id] = u; return m; }, {});
        this.labelSets = data.label_sets.reduce((m, u) => { m[u.id] = u; return m; }, {});
        this.initCharts();
        this.loading = false;
      }).catch((err) => {
        this.logs = err;
        this.loading = false; console.log(err);
      });
    },
    initCharts() {
      const doptions = {
        series: null,
        chart: {
          height: 350,
          type: 'heatmap',
        },
        stroke: {
          width: 0
        },
        plotOptions: {
          heatmap: {
            radius: 30,
            enableShades: false,
            colorScale: {
              ranges: [{ from: 0, to: 5, color: '#eee' },
                { from: 6, to: 50, color: '#008FFB' },
                { from: 51, to: 60 * 5, color: '#00E396' },
                { from: 60 * 5 + 1, to: 60 * 24, color: '#aa0000' },
              ]
            },

          }
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ['#fff']
          }
        },
        xaxis: {
          type: 'category',
        },

        title: {
          text: 'Labelset',
        },
      };

      this.$refs.charts.innerHTML = '';
      Object.keys(this.logs).forEach((label_set_id) => {
        // minute chart
        let element = document.createElement('div');
        this.$refs.charts.appendChild(element);
        let opts = { ...doptions };
        let data = this.logs[label_set_id].byUserByDays;
        opts.series = Object.keys(data).map((user_id) => {
          return {
            // eslint-disable-next-line no-nested-ternary
            name: (user_id == 0) ? this.$dt('time_logs.total_minutes', 'Total minute')
              : (this.users[user_id] ? this.users[user_id].full_name : this.$dt('time_logs.unknown_user', 'Unknown user')),
            data: data[user_id].byDays.map((s) => {
              return { x: s.duration.day.format('DD.MM.YYYY'), y: Math.round(s.duration.d / (60 * 1000)) };
            })
          };
        });
        opts.chart.height = Object.keys(data).length * 40 + 120;
        opts.title.text = (this.labelSets[label_set_id] ? this.labelSets[label_set_id].name : this.$dt('time_logs.unknown_label_set', 'Unknown dataset'))
          + this.$dt('time_logs.duration_title_label', ' - Duration');
        opts.yaxis = { labels: { formatter: function (value) { return `${value} Minutes`; } } };
        let chart = new ApexCharts(element, opts);
        chart.render();

        element = document.createElement('div');
        this.$refs.charts.appendChild(element);
        opts = { ...doptions };
        data = this.logs[label_set_id].byUserByDays;
        opts.series = Object.keys(data).map((user_id) => {
          return {
            // eslint-disable-next-line no-nested-ternary
            name: (user_id == 0) ? this.$dt('time_logs.avg_speed_total', 'Avarage speed')
              : (this.users[user_id] ? this.users[user_id].full_name : this.$dt('time_logs.unknown_user', 'Unknown user')),
            data: data[user_id].byDays.map((s) => {
              return {
                x: s.duration.day.format('DD.MM.YYYY'),
                y: (s.duration.c ? (s.duration.d / (60 * 1000)) / s.duration.c : 0).toFixed(1)
              };
            })
          };
        });
        opts.chart.height = Object.keys(data).length * 40 + 120;
        opts.title.text = (this.labelSets[label_set_id] ? this.labelSets[label_set_id].name : this.$dt('time_logs.unknown_label_set', 'Unknown dataset'))
          + this.$dt('time_logs.speed_title_label', ' - Speed');
        opts.yaxis = { labels: { formatter: function (value) { return `${value} Mins/label`; } } };
        chart = new ApexCharts(element, opts);
        chart.render();

        element = document.createElement('div');
        this.$refs.charts.appendChild(element);
        opts = { ...doptions };
        data = this.logs[label_set_id].byUserByDays;
        opts.series = Object.keys(data).map((user_id) => {
          return {
            // eslint-disable-next-line no-nested-ternary
            name: (user_id == 0) ? this.$dt('time_logs.count_total', 'Count total')
              : (this.users[user_id] ? this.users[user_id].full_name : this.$dt('time_logs.unknown_user', 'Unknown user')),
            data: data[user_id].byDays.map((s) => {
              return { x: s.duration.day.format('DD.MM.YYYY'), y: s.duration.c };
            })
          };
        });
        opts.chart.height = Object.keys(data).length * 40 + 120;
        opts.title.text = (this.labelSets[label_set_id] ? this.labelSets[label_set_id].name : this.$dt('time_logs.unknown_label_set', 'Unknown dataset'))
          + this.$dt('time_logs.count_title_label', ' - Count');
        opts.yaxis = { labels: { formatter: function (value) { return `${value} Count`; } } };
        // eslint-disable-next-line no-unused-expressions
        opts.plotOptions.heatmap.colorScale = {
          ranges: [{ from: 0, to: 1, color: '#eee' },
            { from: 2, to: 5, color: '#008FFB' },
            { from: 6, to: 60 * 5, color: '#00E396' }
          ]
        },
        chart = new ApexCharts(element, opts);
        chart.render();
      });
    }
    // onPageChange(page) {
    //   page = page || this.page;
    //   if (page !== this.page) this.$router.push({ name: 'TimeLogs', params: { page } });
    // },
  }
};
</script>

<style scoped>
</style>
